import React, { useState, useEffect, useRef } from 'react';
import pic1 from "../assets/slide1.webp"
import pic2 from "../assets/slide2.webp"
import pic3 from "../assets/slide3.webp"
import pic4 from "../assets/slide4.webp"
import pic5 from "../assets/slide5.webp"
import pic6 from "../assets/slide6.webp"
import pic7 from "../assets/slide7.webp"
import pic8 from "../assets/slide8.webp"
import pic9 from "../assets/slide9.webp"
import './BlundellsScroll.css';

const BlundellsScroll = () => {
  const [scrollTransitionValue, setScrollTransitionValue] = useState(0);
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const [isMobileView, setIsMobileView] = useState(false);
  const galleryContainerRef = useRef(null);

  const campusImagesList = [
    { 
      imgId: 1, 
      imgSrc: pic1, 
    },
    { 
      imgId: 2, 
      imgSrc: pic2, 
    },
    { 
      imgId: 3, 
      imgSrc: pic3, 
    },
    { 
      imgId: 4, 
      imgSrc: pic4, 
    },
    { 
      imgId: 5, 
      imgSrc: pic5, 
    },
    { 
      imgId: 6, 
      imgSrc: pic6,  
    },
    { 
      imgId: 7, 
      imgSrc: pic7,  
    },
    { 
      imgId: 8, 
      imgSrc: pic8,  
    },
    { 
      imgId: 9, 
      imgSrc: pic9,  
    }
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (isMobileView) {
      setScrollTransitionValue(0.5);
      return;
    }

    const handleScrollEvent = () => {
      if (!galleryContainerRef.current) return;
      
      const containerElement = galleryContainerRef.current;
      const containerTopOffset = containerElement.offsetTop;
      const containerFullHeight = containerElement.offsetHeight;
      const currentScrollPos = window.scrollY;
      const viewportFullHeight = window.innerHeight;
      
      // Carousel triggered earlier - 0.5 instead of 0.7
      const scrollStartPoint = containerTopOffset - viewportFullHeight * 0.5;
      const scrollEffectiveRange = containerFullHeight * 1.2;
      
      if (currentScrollPos >= scrollStartPoint) {
        const calculatedProgress = Math.min(
          Math.max((currentScrollPos - scrollStartPoint) / scrollEffectiveRange, 0), 
          1
        );
        setScrollTransitionValue(Math.min(calculatedProgress, 0.5));
      } else {
        setScrollTransitionValue(0);
      }
    };

    window.addEventListener('scroll', handleScrollEvent);
    handleScrollEvent();
    return () => window.removeEventListener('scroll', handleScrollEvent);
  }, [isMobileView]);

  const navigateToNextSlide = () => {
    setActiveSlideIndex((prevIndex) => (prevIndex + 1) % campusImagesList.length);
  };

  const navigateToPrevSlide = () => {
    setActiveSlideIndex((prevIndex) => (prevIndex - 1 + campusImagesList.length) % campusImagesList.length);
  };

  const jumpToSpecificSlide = (targetIndex) => {
    setActiveSlideIndex(targetIndex);
  };

  const gridDisplayPhase = isMobileView ? 0 : Math.max(0, Math.min(1, 1 - (scrollTransitionValue / 0.15)));
  const stripTransitionPhase = isMobileView ? 0 : Math.max(0, Math.min(1, (scrollTransitionValue - 0.1) / 0.2));
  const zoomTransitionPhase = isMobileView ? 0 : Math.max(0, Math.min(1, (scrollTransitionValue - 0.25) / 0.15));
  const carouselDisplayPhase = isMobileView ? 1 : Math.max(0, Math.min(1, (scrollTransitionValue - 0.25) / 0.15));

  const gridVisibilityOpacity = Math.max(0, gridDisplayPhase - stripTransitionPhase * 0.5);
  const stripVisibilityOpacity = isMobileView ? 0 : Math.max(0, stripTransitionPhase - zoomTransitionPhase * 0.5);
  const zoomVisibilityOpacity = isMobileView ? 0 : Math.max(0, zoomTransitionPhase - carouselDisplayPhase);
  const carouselVisibilityOpacity = isMobileView ? 1 : carouselDisplayPhase;

  return (
    <div className="blundells-main-wrapper">
      <div 
        ref={galleryContainerRef} 
        className="blundells-gallery-section-wrapper"
      >
        <div className="blundells-gallery-inner-container">
          
          {/* Phase 1: Grid Layout - Desktop Only */}
          {!isMobileView && (
            <div 
              className="blundells-grid-layout-container"
              style={{ 
                opacity: gridVisibilityOpacity,
                pointerEvents: gridDisplayPhase > 0.5 ? 'auto' : 'none'
              }}
            >
              <div className="blundells-grid-content-wrapper">
               <h2 className="blundells-gallery-section-title">
  A <span className="highlight-word">co-educational</span> independent school
</h2>

                <div className="blundells-grid-images-wrapper">
                  {campusImagesList.map((imageItem) => (
                    <div
                      key={imageItem.imgId}
                      className="blundells-grid-single-item"
                      style={{ 
                        transform: `scale(${1 - (1 - gridDisplayPhase) * 0.15})`
                      }}
                    >
                      <img
                        src={imageItem.imgSrc}
                        alt={imageItem.imgCaption}
                        className="blundells-grid-item-image"
                      />
                      <div className="blundells-grid-item-overlay">
                        <p className="blundells-grid-item-caption">{imageItem.imgCaption}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Phase 2: Wide Strip - Desktop Only */}
          {!isMobileView && (
            <div 
              className="blundells-strip-transition-container"
              style={{ 
                opacity: stripVisibilityOpacity,
                pointerEvents: 'none'
              }}
            >
              <div className="blundells-strip-content-wrapper">
                <div 
                  className="blundells-strip-images-holder"
                  style={{ 
                    height: `${150 + stripTransitionPhase * 100}px`,
                  }}
                >
                  <div className="blundells-strip-images-flex">
                    {campusImagesList.map((imageItem) => (
                      <div 
                        key={imageItem.imgId} 
                        className="blundells-strip-single-image"
                        style={{
                          transform: `scale(${0.98 + stripTransitionPhase * 0.02})`,
                        }}
                      >
                        <img
                          src={imageItem.imgSrc}
                          alt={imageItem.imgCaption}
                          className="blundells-strip-img-element"
                          style={{ filter: `brightness(${0.7 + stripTransitionPhase * 0.3})` }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Phase 3: Zoom Transition - Desktop Only */}
          {!isMobileView && (
            <div 
              className="blundells-zoom-transition-container"
              style={{ 
                opacity: zoomVisibilityOpacity,
                pointerEvents: 'none'
              }}
            >
              <div className="blundells-zoom-content-wrapper">
                <div 
                  className="blundells-zoom-image-holder"
                  style={{
                    transform: `scale(${1 + zoomTransitionPhase * 0.3})`,
                  }}
                >
                  <img
                    src={campusImagesList[0].imgSrc}
                    alt={campusImagesList[0].imgCaption}
                    className="blundells-zoom-img-element"
                  />
                </div>
              </div>
            </div>
          )}

          {/* Phase 4: Carousel/Slider */}
          <div
            className="blundells-carousel-container"
            style={{
              opacity: carouselVisibilityOpacity,
              pointerEvents: isMobileView || carouselDisplayPhase > 0.3 ? 'auto' : 'none',
            }}
          >
            <div className="blundells-carousel-content-wrapper">
              <div className="blundells-carousel-inner-box">
                 <h2 className="blundells-gallery-section-title">
                A <span className="highlight-word">co-educational</span> independent school
                 </h2>
                <div className="blundells-carousel-slider-wrapper">
                  <div className="blundells-carousel-slides-container">
                    <img
                      key={`slide-${activeSlideIndex}`}
                      src={campusImagesList[activeSlideIndex].imgSrc}
                      alt={campusImagesList[activeSlideIndex].imgCaption}
                      className="blundells-carousel-slide-image"
                      style={{
                        animation: 'blundellsFadeIn 0.6s ease-in-out',
                        imageRendering: 'high-quality'
                      }}
                    />
                    <div className="blundells-carousel-slide-caption-box">
                      <p className="blundells-carousel-caption-text">
                        {campusImagesList[activeSlideIndex].imgCaption}
                      </p>
                    </div>
                  </div>

                  {/* Navigation Buttons */}
                  <button
                    onClick={navigateToPrevSlide}
                    className="blundells-carousel-nav-btn blundells-nav-btn-prev"
                    aria-label="Previous slide"
                  >
                    <svg className="blundells-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                  </button>
                  <button
                    onClick={navigateToNextSlide}
                    className="blundells-carousel-nav-btn blundells-nav-btn-next"
                    aria-label="Next slide"
                  >
                    <svg className="blundells-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlundellsScroll;